import React, { Component } from "react";
import casestudy from "../assets/casestudy.svg";
import { renderMarkup } from "../utils.js";
import { Link } from "react-router-dom";
import _ from "lodash";

class OtherPosts extends Component {
  render() {
    const { data, bgColor, color, postMax } = this.props;

    return (
      <div className="wrapper other-posts" style={{ backgroundColor: bgColor }}>
        <div className="top-header">
          <img src={casestudy} alt="Case Study" />
          <h2 style={{ color: color }}>More Applications</h2>
        </div>
        <div className="more-cs max-width">
          {_.map(data, (o, i) => {
            if (i > 0 && i < postMax) {
              return (
                <div className="cs-box">
                  <h4>Application</h4>
                  <h2
                    dangerouslySetInnerHTML={renderMarkup(o.title.rendered)}
                  />
                  <p dangerouslySetInnerHTML={renderMarkup(o.acf.excerpt)}/>
                  <Link className="btn main" to={"/case/" + o.slug}>
                    Read Case Study
                  </Link>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

export default OtherPosts;



// WEBPACK FOOTER //
// ./src/components/OtherPosts.js